import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.css']
})
export class RankingComponent implements OnInit {

  @Input("ranking") value;
  @Input("reviews") reviews;
  stars_f;
  stars_o;
  offset;
  constructor() { 
    
  }

  ngOnInit() {
    this.offset = 5 - this.value;
    this.value = parseFloat(this.value);    
    this.stars_f = new Array(parseInt(this.value)).fill(1).map((x, i) => i + 1);   
    this.stars_o = new Array(Math.floor(this.offset)).fill(1).map((x, i) => i + 1);
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/ranking/ranking.component.ts